import React, { createContext, useContext, useState } from "react";

const NavigationContext = createContext();

export function NavigationProvider({ children }) {
  const [breadcrumbStack, setBreadcrumbStack] = useState([]);
  return (
    <NavigationContext.Provider value={{ breadcrumbStack, setBreadcrumbStack }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useNavigationContext() {
  return useContext(NavigationContext);
}
